import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { Account } from '@jaimo-solutions-gmbh/platform-services-module';
import {
  faArrowUpRightFromSquare,
  faPhone,
  faShare,
} from '@fortawesome/free-solid-svg-icons';
import { openShare } from 'src/helpers';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { getImagePath } from 'src/app/utils/getImagePath';

@Component({
  selector: 'app-mobile-popover',
  templateUrl: './mobile-popover.component.html',
  styleUrls: ['./mobile-popover.component.scss'],
})
export class MobilePopoverComponent implements OnInit {
  account?: Account;
  mail: string;
  phone: string;
  website: string;

  linkIcon = faArrowUpRightFromSquare;
  mailIcon = faEnvelope;
  phoneIcon = faPhone;
  shareIcon = faShare;

  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.account = this.navParams.get('account');
    if (this.account) {
      this.mail = this.account.email;
      this.phone = this.account.phone;
      this.website = this.account.website;
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }

  sendMail() {
    location.href = this.mail;
  }

  call() {
    location.href = this.phone;
  }

  splitProtocol = (value: string) => value.split(':')[1] ?? '';

  visit() {
    location.href = this.website;
  }

  getImage = (filename?: string) => getImagePath() + filename;

  openShare = (account: Account) => {
    this.modalCtrl.dismiss().then(() => {
      openShare(account, this.modalCtrl);
    });
  };

  navigate = (type: string) => {
    window.open('https://about.stage.bio/' + type);
  };
}
